var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStepDoneSymbol = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_207_282)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19.84,
    cy: 19.84,
    r: 18.6,
    fill: "#0088FF",
    stroke: "#0088FF",
    strokeWidth: 2.48
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.757 24.5161L27.7131 12.56L29.3006 14.1475L15.757 27.6911L9.45996 21.3959L11.0475 19.8084L15.757 24.5161Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_207_282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.68,
    height: 39.68,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStepDoneSymbol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/stepDoneSymbol.0c1945e409c9a3335672d79f21fdb74e.svg";